import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../api';
import { Field } from './ProductsTab';
import ReorderRemindersCard from './ReorderRemindersCard';

const EMPTY_FORM = { current_password: '', new_password: '', confirm: '' };

const SettingsTab = () => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error('New passwords do not match'); return; }
    setBusy(true);
    try {
      await api.put('/auth/password', { current_password: form.current_password, new_password: form.new_password });
      toast.success('Password updated');
      setForm(EMPTY_FORM);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl space-y-8">
      <ReorderRemindersCard />

      <div className="max-w-lg">
        <h2 className="text-xl font-bold text-[#0a0a0a]">Change password</h2>
        <p className="text-sm text-slate-500 mt-1">Update the password for your account.</p>
        <form onSubmit={submit} className="mt-6 space-y-4 bg-white border border-slate-200 rounded-xl p-5">
          <Field label="Current password"><input required type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="input" /></Field>
          <Field label="New password"><input required minLength={6} type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="input" /></Field>
          <Field label="Confirm new password"><input required minLength={6} type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="input" /></Field>
          <button type="submit" disabled={busy} className="inline-flex items-center gap-2 px-5 py-2 bg-red-500 hover:bg-red-400 text-white text-sm font-semibold rounded-lg disabled:opacity-60">
            {busy && <Loader2 size={14} className="animate-spin" />} Update password
          </button>
        </form>
      </div>
    </div>
  );
};

export default SettingsTab;
